export const addArticleSuccess = {
  title: 'Success',
  message: 'Saved position',
  position: 'tr',
  autoDismiss: 6
}

export const addArticleError = {
  title: 'Error',
  message: 'Saving a position failed',
  position: 'tr',
  autoDismiss: 6
}

export const loginSuccess = {
  title: 'Success',
  message: 'You are logged in',
  position: 'tr',
  autoDismiss: 6
}

export const loginError = {
  title: 'Error',
  message: 'An error occurred during login',
  position: 'tr',
  autoDismiss: 6
}

export const logoutSuccess = {
  title: 'Success',
  message: 'You are logged out',
  position: 'tr',
  autoDismiss: 6
}

export const logoutError = {
  title: 'Error',
  message: 'An error occurred during logout',
  position: 'tr',
  autoDismiss: 6
}

export const delArticleSuccess = {
  title: 'Success',
  message: 'Deleted position',
  position: 'tr',
  autoDismiss: 6
}

export const delArticleError = {
  title: 'Error',
  message: 'Delete a position failed',
  position: 'tr',
  autoDismiss: 6
}

export const addEmailSuccess = {
  title: 'Success',
  message: 'Saved email',
  position: 'tr',
  autoDismiss: 6
}

export const addEmailError = {
  title: 'Error',
  message: 'Saving an email failed',
  position: 'tr',
  autoDismiss: 6
}

export const delEmailSuccess = {
  title: 'Success',
  message: 'Deleted email',
  position: 'tr',
  autoDismiss: 6
}

export const delEmailError = {
  title: 'Error',
  message: 'Delete an email failed',
  position: 'tr',
  autoDismiss: 6
}

export const addKeywordSuccess = {
  title: 'Success',
  message: 'Saved keyword',
  position: 'tr',
  autoDismiss: 6
}

export const addKeywordError = {
  title: 'Error',
  message: 'Saving a keyword failed',
  position: 'tr',
  autoDismiss: 6
}

export const delKeywordSuccess = {
  title: 'Success',
  message: 'Deleted keyword',
  position: 'tr',
  autoDismiss: 6
}

export const delKeywordError = {
  title: 'Error',
  message: 'Delete a keyword failed',
  position: 'tr',
  autoDismiss: 6
}

export const emailExistError = {
  title: 'Error',
  message: 'Email is in newsletter',
  position: 'tr',
  autoDismiss: 6
}

export const addActorSuccess = {
  title: 'Success',
  message: 'Saved actor',
  position: 'tr',
  autoDismiss: 6
}

export const addActorError = {
  title: 'Error',
  message: 'Saving an actor failed',
  position: 'tr',
  autoDismiss: 6
}

export const delActorSuccess = {
  title: 'Success',
  message: 'Deleted actor',
  position: 'tr',
  autoDismiss: 6
}

export const delActorError = {
  title: 'Error',
  message: 'Delete an actor failed',
  position: 'tr',
  autoDismiss: 6
}

export const addFieldSuccess = {
  title: 'Success',
  message: 'Saved field',
  position: 'tr',
  autoDismiss: 6
}

export const addFieldError = {
  title: 'Error',
  message: 'Saving a field failed',
  position: 'tr',
  autoDismiss: 6
}

export const delFieldSuccess = {
  title: 'Success',
  message: 'Deleted field',
  position: 'tr',
  autoDismiss: 6
}

export const delFieldError = {
  title: 'Error',
  message: 'Delete a field failed',
  position: 'tr',
  autoDismiss: 6
}



// WEBPACK FOOTER //
// ./src/store/toasts.js